import Script from 'next/script';

export function FueledShopMyScript({ withKey: shopMyScriptId }) {
  return (
    <Script src={`https://static.shopmy.us/Affiliates/${shopMyScriptId}.js`} />
  );
}
